import React from "react";
import { Link } from "react-router-dom";

import SignIn from "@/components/SignIn";
import { Card, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";

const SignInPage: React.FC = () => {
    return (
        <div className="flex min-h-screen w-full items-center justify-center bg-muted/20 px-4">
            <Card className="w-full max-w-md">
                <CardContent className="p-6 space-y-6">
                    {/* Form */}
                    <SignIn />

                    <Separator />

                    {/* Footer link */}
                    <div className="text-center text-sm text-muted-foreground">
                        <span className="mr-1">Нет аккаунта?</span>
                        <Button
                            asChild
                            variant="link"
                            className="px-1 h-auto"
                        >
                            <Link to="/signup">Зарегистрироваться</Link>
                        </Button>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
};

export default SignInPage;
